import { CommonAPIService } from './common.service';
import { inject, Injectable } from '@angular/core';

import { AddAdminRequest, AdminUserRequest, ChangePasswordAdminRequest, UpdateAdminRequest } from '../shared/models/admin-user.model';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  private commonService = inject(CommonAPIService);

  public AdminUser: Subject<string> = new BehaviorSubject<any>(null);
  adminData;
  userModalType;
  roleList;

  constructor() { }

  updateStatus(id) {
    return this.commonService.get(`/admin_users/${id}/status`);
  }

  cameraPromptButtonStatus(id, data) {
    console.log("data ::", data);
    return this.commonService.post(`/admin_users/change-camera-status/${id}`, data);
  }

  changeCallPermissionStatus(id, data) {
    return this.commonService.post(`/admin_users/call-permission/${id}`, data);
  }

  changeDynamicFormPermissionStatus(id, data) {
    return this.commonService.post(`/admin_users/dynamic-form-permission/${id}`, data);
  }

  adminUsersList(params: AdminUserRequest) {
    return this.commonService.post('/admin_users/list', params);
  }

  adminUsersListAll(params) {
    return this.commonService.post('/admin_users/list', params);
  }

  deleteUser(id: any, removeFromTeam: boolean = false) {
    const url = '/users/' + id + (removeFromTeam ? '?removeFromTeam=true' : '');
    return this.commonService.delete(url);
  }

  getUserTeamAssignments(id: any) {
    return this.commonService.get('/users/' + id + '/team-assignments');
  }

  updateUserTeams(id: any, teamIds: string[]) {
    return this.commonService.post('/users/' + id + '/teams', { teamIds });
  }

  getUserShifts(id: any) {
    return this.commonService.get('/users/' + id + '/shifts');
  }


  getAllUserShiftPlans() {
    return this.commonService.get('/users/shift-plans');
  }

  /**
   * Replaces the user's whole shift plan. The API also assigns the user to every team the
   * plan names, so this call covers both — do not pair it with updateUserTeams.
   */
  updateUserShifts(id: any, shifts: { team: string; date: string; start_time: string; end_time: string }[]) {
    return this.commonService.post('/users/' + id + '/shifts', { shifts });
  }

  /** The user's manual cover assignment, or `assignment: null` when they have none. */
  getUserCoverAssignment(id: any) {
    return this.commonService.get('/users/' + id + '/cover-assignment');
  }

  /**
   * Sets the user's manual cover assignment — a bounded stand-in on one team shift.
   *
   * Additive, unlike the shift plan: it leaves the user's own team membership and weekly
   * plan alone, so a backup operator keeps their own roster and simply also receives the
   * covered shift's alerts. Send `team: null` to clear the assignment.
   */
  updateUserCoverAssignment(id: any, payload: {
    team: string | null;
    shift_id?: string | null;
    starts_at?: string | null;
    ends_at?: string | null;
    auto_return?: boolean;
    reason?: string;
  }) {
    return this.commonService.post('/users/' + id + '/cover-assignment', payload);
  }

  addUsers(params: AddAdminRequest) {
    return this.commonService.post('/admin_users', params);
  }

  updateUsers(params: UpdateAdminRequest, id) {
    return this.commonService.post(`/admin_users/update-profile/${id}`, params);
  }

  adminChangePassword(data: ChangePasswordAdminRequest, id) {
    return this.commonService.post(`/admin_users/change-password/${id}`, data);
  }
}
